import { extendTheme } from '@chakra-ui/react';
import { Color } from './color';
import { convertSnakeToCamelCase } from '../utils/parser';
import { input } from './components/input';
import { button } from './components/button';

const colors = Object.keys(Color).reduce(
	(accumulator, key) => ({
		...accumulator,
		[convertSnakeToCamelCase(key)]: Color[key as keyof typeof Color],
	}),
	{}
);

export const customTheme = extendTheme({
	colors: {
		transparent: 'transparent',
		white: '#ffffff',
		field: {
			background: '#111111',
			addon: '#272727',
			placeholder: '#686868',
			border: '#4E4F52',
		},
		cartridge: {
			red: '#FF3F3F',
			blue: '#468CF4',
			gold: '#BEA379',
			gray: '#9D9D9D',
			green: '#6AAD38',
		},
		steps: {
			background: '#9D9D9D',
		},
		...colors /** @dev Defined in `Color` enumeration */,
	},
	components: {
		Switch: {
			baseStyle: {
				track: {
					_focus: {
						boxShadow: 'none',
					},
				},
			},
		},
		Button: button,
		Input: input,
	},
	fonts: {
		body: 'Sora, sans-serif',
		heading: 'Sora, sans-serif',
	},
	config: {
		initialColorMode: 'system',
		useSystemColorMode: true,
		disableTransitionOnChange: false,
	},
	baseStyle: {
		body: {
			height: '100vh',
		},
	},
	styles: {
		global: ({ colorMode }: any) => ({
			'html, body': {
				color: 'white',
				bg: 'black',
				fontFamily: 'Sora',
			},
			_focus: {
				boxShadow: 'none !important',
				outline: 'none !important',
			},
			_focusVisible: {
				boxShadow: 'none !important',
				outline: 'auto !important',
			},
		}),
	},
});
